import { useTheme } from 'styled-components';
import { handleColorType } from '@quizzach/styles';

export const Success = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M30.8321 12.5541C31.1384 12.0945 31.0142 11.4737 30.5547 11.1673C30.0952 10.861 29.4743 10.9852 29.168 11.4447L16.9432 29.7824L11.8719 23.168C11.5358 22.7297 10.9081 22.6468 10.4698 22.9829C10.0315 23.3189 9.94865 23.9466 10.2847 24.3849L15.356 30.9993C16.1902 32.0873 17.8468 32.0325 18.6073 30.8918L30.8321 12.5541Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21ZM40 21C40 31.4934 31.4934 40 21 40C10.5066 40 2 31.4934 2 21C2 10.5066 10.5066 2 21 2C31.4934 2 40 10.5066 40 21Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
